import { ContainerComponent, wrap, Wrapper as ReactAppWrapper } from "AppReact";
import Controller from "./controller";
import internalState from "./internalState";
import { Wrapper, ButtonsWrapper } from "./wrappers";
import {
  SecondaryTextSm,
  ImagePreviewCard,
  ImagePreviewPlaceholderCard,
} from "atoms";
import { Mt2, CursorPointerWrapper } from "wrappers";
import styled from "styled-components";
import { VIDEO_STATUS_MAP } from "../../modals/trainingVideoModal/contants";

export const definition = {
  name: "VideoCard",
  controller: Controller,
  initialProps: ({ videoCard, categoryId }) => ({ videoCard, categoryId }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(Wrapper, CursorPointerWrapper),
      name: "VideoCardWrapper",
      isButton: true,
      bindings: ({ videoCard }) => ({ videoCard }),
      elements: [
        {
          component: wrap(ImagePreviewCard, Wrapper),
          name: "UploadedImage",
          displayState: ({ preview }) => ({ preview }),
          renderIf: ({ videoCard }) => !!videoCard && !!videoCard.thumbnail,
          displayValue: ({ videoCard }) => videoCard?.thumbnail ?? "",
          bindings: ({ videoCard }) => {
            return {
              videoCard,
              src: videoCard?.thumbnail,
            };
          },
        },
        {
          component: ImagePreviewPlaceholderCard,
          name: "UploadedImage",
          renderIf: ({ videoCard }) => !videoCard?.thumbnail,
          displayValue: ({ videoCard }) => videoCard?.thumbnail ?? "",
        },
        {
          wrapper: ButtonsWrapper,
          name: "Buttons",
          elements: [],
          renderIf: ({ videoCard }) => {
            return (
              videoCard.status !== VIDEO_STATUS_MAP.PUBLISHED.toLowerCase()
            );
          },
        },
      ],
    },
    {
      component: wrap(
        wrap(
          SecondaryTextSm,
          ReactAppWrapper(
            styled.div`
              max-width: 230px;
            `
          )
        ),
        Mt2
      ),
      name: "VideoTitle",
      displayValue: ({ videoCard }) => videoCard.title ?? "",
      displayState: ({ videoCard }) => {
        let opacity = 1;
        let color  = null;
        if (videoCard.status !== VIDEO_STATUS_MAP.PUBLISHED.toLowerCase()) {
          opacity = 0.5;
          color = "#D2D2D2";
        }
        return {
          opacity,
        };
      },
    },
  ],
};

export default ContainerComponent(definition);
